import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

export const routes = [
  {
    path: '/',
    redirect: '/vendor/manufactureruserlist'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/Login.vue')
  }
]

export const authRoutes = [
    {
      path: '/vendor',
      name: 'Vendor',
      redirect: "/vendor/manufactureruserlist ",
      component: () => import('../views/layout/default/index.vue'),
      meta: {
        "title": "后台管理",
        icon: 'el-icon-printer',
      },
      children: [
        {
          path: 'manufactureruserlist',
          name: 'ManufacturerUserList',
          component: () => import('../views/manufacturer-user-list/index.vue'),
          meta: {
            "title": "上游信息"
          },
        },
        {
          path: 'fundingdetails',
          name: 'FundingDetails',
          component: () => import('../views/funding-details/index.vue'),
          meta: {
            "title": "订单记录"
          },
        },
      ]
    },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes: [...routes, ...authRoutes]
});

router.beforeEach((to, from, next) => {
  // console.log("----",to.path, )
  // if (to.path !== '/login' && !store.state.userInfo.login) {
  //   next('/login');
  // } else {
  //   next();
  // }

  if (to.path !== '/login') {
    const findObj = store.state.toolList.find(item => item['url'] == to.href);
    if (!findObj) {
      store.commit('setToolList', {
        name: to.meta.title || 'Not',
        url: to.href
      })
    }
  }

  // 如果去login，如果登录了，去home
  // 如果去login，没登录 next
  // 如果不去login，如果没登录，去login
  // 如果不去login，如果登录了，next
  if (to.path == '/login' && store.state.userInfo.login) {
    next('/vendor/manufactureruserlist')
  } else if (to.path == '/login' && !store.state.userInfo.login) {
    next()
  } else if (to.path !== '/login' && !store.state.userInfo.login) {
    next('/login')
  } else if (to.path !== '/login' && store.state.userInfo.login) {
    next()
  } else {
    console.error(123)
    next()
  }
});

export default router;
